/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:35
 * @LastEditTime: 2021-03-04 16:23:10
 */
import i18n from "../../../common/lang";
export const Columns=[
    {LabelName:i18n.t('lang.customermanagement.customerName'),key:0,ColumnsKey:'c_name',seek:'c_name',placeholder:i18n.t('lang.customermanagement.search1'), sort: 'custom'},
    {LabelName:i18n.t('lang.customermanagement.Customer'),key:1,ColumnsKey:'c_id',seek:'c_id',placeholder:i18n.t('lang.customermanagement.search2'), sort: 'custom'},
    {LabelName:i18n.t('lang.customermanagement.Admin'),key:2,ColumnsKey:'userName',seek:'userName',placeholder:i18n.t('lang.customermanagement.search3'), sort: 'custom'},
    {LabelName:i18n.t('lang.customermanagement.Contact'),key:3,ColumnsKey:'cContact',seek:'cContact',placeholder:i18n.t('lang.customermanagement.search4'), sort: 'custom'},
    {LabelName:i18n.t('lang.customermanagement.phone'),key:4,ColumnsKey:'cTel',seek:'cTel',placeholder:i18n.t('lang.customermanagement.search5'), sort: 'custom'},
    {LabelName:i18n.t('lang.customermanagement.Email'),key:5,ColumnsKey:'cEmail',seek:'cEmail',placeholder:i18n.t('lang.customermanagement.search6'), sort: 'custom'},
  {LabelName:i18n.t('lang.customermanagement.detailed'),key:6,ColumnsKey:'cAddress',seek:'cAddress',placeholder:i18n.t('lang.customermanagement.search7'), sort: 'custom'},
  {LabelName:i18n.t('lang.customermanagement.services'),key:7,ColumnsKey:'superlink',seek:'superlink',placeholder:i18n.t('lang.customermanagement.search8'),Fun:'GetServer', sort: 'custom'}
]

export const ColuumnsButton=[
    {key:0,type:'primary',icon:'el-icon-edit',Fun:'modificationCustomer',Authority:137},
    {key:1,type:'danger',icon:'el-icon-delete',Fun:'deleteCustomer',Delete:true,Authority:138}
]
